import React from "react";
import { Route } from "react-router-dom";
// import Reports from "pages/reports/Reports";
import Dashboard from "pages/dashboard/Dashboard";
import ParentWithoutStudentList from "pages/parents/ParentWithoutStudentList";
import PersonInChargeWithoutStudentList from "./pages/personInCharges/PersonInChargeWithoutStudentList";

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  // <Route exact path="/reports" render={() => <Reports />} />,
  <Route exact path="/dashboard" render={() => <Dashboard />} />,
  <Route
    exact
    path="/parentsWithoutStudent"
    render={() => <ParentWithoutStudentList />}
  />,
  <Route
    exact
    path="/personInChargesWithoutStudent"
    render={() => <PersonInChargeWithoutStudentList />}
  />,
];
